import React from 'react';
import { View } from 'react-native';
import { Menu, MenuItem, MenuItemLabel } from '@/components/gluestack/menu';
import { Button, ButtonIcon, ButtonText } from '@/components/gluestack/button';
import { CheckIcon, ChevronDownIcon, Icon } from '@/components/gluestack/icon';

export interface IMenuSelectOption {
  key: string;
  label: string;
  leftAccessory?: React.ReactNode;
}

export interface IMenuSelectButtonProps {
  selectedKey: string;
  options: IMenuSelectOption[];
  onSelect: (key: string) => void;
  valueLabel?: string;
  /**
   * Optional custom trigger renderer. Use this when the trigger needs icons/flags/custom layout.
   * If provided, the default button trigger is not used.
   */
  trigger?: (triggerProps: any) => React.ReactNode;
  placement?: 'bottom left' | 'bottom right' | 'top left' | 'top right';
  offset?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'solid' | 'outline' | 'link';
  action?: 'primary' | 'secondary' | 'positive' | 'negative' | 'neutral';
  className?: string;
  textClassName?: string;
  iconClassName?: string;
}

export function MenuSelectButton({
  selectedKey,
  options,
  onSelect,
  valueLabel,
  trigger,
  placement = 'bottom right',
  offset = 8,
  size = 'xs',
  variant = 'solid',
  action,
  className,
  textClassName,
  iconClassName,
}: IMenuSelectButtonProps) {
  return (
    <Menu
      placement={placement}
      offset={offset}
      trigger={
        trigger
          ? trigger
          : ({ ...triggerProps }) => (
              <Button
                {...triggerProps}
                size={size}
                variant={variant}
                action={action}
                className={className}>
                <ButtonText className={textClassName}>{valueLabel ?? ''}</ButtonText>
                <ButtonIcon as={ChevronDownIcon} size="sm" className={iconClassName} />
              </Button>
            )
      }>
      {options.map((opt) => (
        <MenuItem key={opt.key} textValue={opt.label} onPress={() => onSelect(opt.key)}>
          {opt.leftAccessory ? <View className="mr-3">{opt.leftAccessory}</View> : null}
          <MenuItemLabel>{opt.label}</MenuItemLabel>
          {opt.key === selectedKey && (
            <Icon as={CheckIcon} size="sm" className="ml-2 color-typography-700" />
          )}
        </MenuItem>
      ))}
    </Menu>
  );
}


